import { useEffect } from 'react';
import { InvoiceInfoDto, InvoicePermissions, IPagingData } from '@sr/dto';
import { changeInvoiceCanceledStatus } from '../api';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { useActionCreators, useStateSelector } from 'shared/store';
import { clientInvoicesThunks } from '../model/thunks';
import { useUserAuth } from 'features/auth';

export const useClientInvoices = (paging: IPagingData, filterString?: string, companyId?: number) => {
  const { fetchClientInvoicesThunk } = useActionCreators(clientInvoicesThunks);
  const { user } = useUserAuth();
  const showAll = user?.permissions.some((p) => p === InvoicePermissions.ANY_CLIENT_INVOICES || p === InvoicePermissions.EDIT_INVOICE);
  const fetchArgs = { paging, filter: `${filterString}${showAll ? '&showAll=true' : ''}`, companyId };
  useEffect(() => {
    fetchClientInvoicesThunk(fetchArgs);
  }, [paging, filterString, companyId, fetchClientInvoicesThunk, showAll]);

  const collection: IRemotePagedCollection<InvoiceInfoDto> = {
    collection: useStateSelector((state) => state.invoicesList.invoicesList),
    isLoading: useStateSelector((state) => state.invoicesList.meta.status === 'loading'),
    error: useStateSelector((state) => state.invoicesList.meta.error),
    reload: () => {
      fetchClientInvoicesThunk({ paging, filter: `${filterString}${showAll ? '&showAll=true' : ''}`, companyId }); 
    }
  };

  const changeInvoiceStatus = (id: number) => changeInvoiceCanceledStatus(id);

  return {
    collection,
    changeCancelStatus: changeInvoiceStatus,
  };
};
